import React, { useEffect } from "react";
import { DefaultLayout } from "../../layouts/DefaultLayout";

function HowToPlay() {
    useEffect(() => {
    }, []);
    return (
        <DefaultLayout title="How To Play">
            {<>

                    <section className='py-8'>
                        <div className="container">
                            <div className="flex items-center gap-2 mb-6 justify-center">
                                <h4 className='font-bold text-[20px] text-white'>How To Play</h4>
                            </div>


                        </div>
                    </section>
                    <section className='py-8'>
                        <div className="container pb-[35px]">
                            <div className="flex items-center gap-2 mb-6 justify-center">
                                <h4 className='font-bold text-[20px] text-white cursor-pointer'>Step 1: Explore Games</h4>
                            </div>

                            <div className="flex items-center justify-center">
                              <img src={`./how-to-1.png`} className=' object-cover' alt="logo" />
                            </div>

                            <div className='pt-[10px]'>
                              VP Game Center includes dozens of games across various categories. New games are added frequently, so check back periodically for new releases!
                            </div>
                            <div className='pt-[10px]'>
                              New releases and top games are listed on the homepage. From the “Games” page, tap on any category to see a selection of relevant games, or click the “Leaderboard Support” box to view games with leaderboard support enabled.
                            </div>

                        </div>
                        <div className="container pb-[35px]">
                            <div className="flex items-center gap-2 mb-6 justify-center">
                                <h4 className='font-bold text-[20px] text-white cursor-pointer'>Step 2: Play Games</h4>
                            </div>

                            <div className="flex items-center justify-center">
                              <img src={`./how-to-2.png`} className=' object-cover' alt="logo" />
                            </div>

                            <div className='pt-[10px]'>
                              Play each name by either tapping on the game’s picture, or by tapping the “Play Now” button. See each game’s description and a few preview images by tapping  “More Info”  found below the game image.
                            </div>

                        </div>
                        <div className="container pb-[35px]">
                            <div className="flex items-center gap-2 mb-6 justify-center">
                                <h4 className='font-bold text-[20px] text-white cursor-pointer'>Step 3: Leaderboard Ranking</h4>
                            </div>

                            <div className="flex items-center justify-center">
                              <img src={`./how-to-3.png`} className=' object-cover' alt="logo" />
                            </div>

                            <div className='pt-[10px]'>
                              Many of the games in VP Game Center have leaderboards that are shared by all correctional facilities within our network! Play selected games to compete with other players to climb at the top of the leaderboard.
                            </div>
                            <div className='pt-[10px]'>
                              Tap the checkbox next to “Leaderboard Support” to view all games that have leaderboard rankings.
                            </div>

                        </div>
                        <div className="container">
                            <div className="flex items-center gap-2 mb-6 justify-center">
                                <h4 className='font-bold text-[20px] text-white cursor-pointer'>Step 4: Player Accounts</h4>
                            </div>

                            <div className="flex items-center justify-center">
                              <img src={`./how-to-4.png`} className=' object-cover' alt="logo" />
                            </div>

                            <div className='pt-[10px]'>
                              To view your player account simply click the avatar icon with your username found at the top right corner of the screen.
                            </div>
                            <div className='pt-[10px]'>
                              Edit your profile avatar, view recently played games, and see your top high scores in your player account.
                            </div>

                        </div>
                    </section>
                    <section className='py-8'>
                        <div className="container">
                            <div className="flex items-center gap-2 mb-6 justify-center">
                                <h4 className='font-bold text-[20px] text-white'>ENJOY!</h4>
                            </div>


                        </div>
                    </section>
            </>}
        </DefaultLayout>
    )
}

export default HowToPlay;
